// store.ts

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import filtersReducer from './reducers/filter-settings/filterSlice';  // Importez votre reducer pour filterDate ici
import {
  auth,
  media,
  social,
  resources,
  metrics,
  workspaces,
  csrf,
  dashboard,
  admin,
  businessOverview,
  brandOverview,
  countries,
  competitorsMonitoring,
  liveBidding,
  campaignLeaks,
  sso,
  onboard,
  cockpit,
  conversionsAnalysis,
  visibility,
  activations,
  googleAPI,
  filters,
  extAPI,
  conversions,
  jobsAPI,
  tagAPI,
  currencies,
  exports,
  leaderboard,
  brandColorAPI,
  brandInfringement
} from './api';
import { appSettings } from './reducers';
import adsUiReducer from './reducers/visibility/adsSlice';
import { performance } from './api/performance/api';
import { dataApi } from './api/data/api';
import nonBrandedAPI from './api/non-branded/api';
import brandPulse from './api/brandPulse/api';
import bidStratTesting from './api/bidStratTesting/api';


export const apiState = {
  [auth.reducerPath]: auth,
  [media.reducerPath]: media,
  [social.reducerPath]: social,
  [conversions.reducerPath]: conversions,
  [metrics.reducerPath]: metrics,
  [resources.reducerPath]: resources,
  [workspaces.reducerPath]: workspaces,
  [performance.reducerPath]: performance,
  [liveBidding.reducerPath]: liveBidding,
  [csrf.reducerPath]: csrf,
  [businessOverview.reducerPath]: businessOverview,
  [brandOverview.reducerPath]: brandOverview,
  [competitorsMonitoring.reducerPath]: competitorsMonitoring,
  [campaignLeaks.reducerPath]: campaignLeaks,
  [admin.reducerPath]: admin,
  [dashboard.reducerPath]: dashboard,
  [countries.reducerPath]: countries,
  [sso.reducerPath]: sso,
  [onboard.reducerPath]: onboard,
  [dataApi.reducerPath]: dataApi,
  [cockpit.reducerPath]: cockpit,
  [conversionsAnalysis.reducerPath]: conversionsAnalysis,
  [visibility.reducerPath]: visibility,
  [googleAPI.reducerPath]: googleAPI,
  [activations.reducerPath]: activations,
  [bidStratTesting.reducerPath]: bidStratTesting,
  [filters.reducerPath]: filters,
  [extAPI.reducerPath]: extAPI,
  [jobsAPI.reducerPath]: jobsAPI,
  [nonBrandedAPI.reducerPath]: nonBrandedAPI,
  [tagAPI.reducerPath]: tagAPI,
  [currencies.reducerPath]: currencies,
  [brandPulse.reducerPath]: brandPulse,
  [exports.reducerPath]: exports,
  [leaderboard.reducerPath]: leaderboard,
  [brandColorAPI.reducerPath]: brandColorAPI,
  [brandInfringement.reducerPath]: brandInfringement,
}

const reducer = combineReducers(Object.assign({},
  Object.entries(apiState).reduce((acc, [key, value]) => ({ ...acc, [key]: value.reducer }), {} as Record<keyof typeof apiState, typeof apiState[keyof typeof apiState]['reducer']>),
  {
    appSettings: appSettings, // Propriété 2
    filters: filtersReducer,  // Propriété 3
    visibilityAdsUi: adsUiReducer,
  }
)
);

const store = configureStore({
  reducer,
  middleware: (defaultMiddleware) =>
    defaultMiddleware().concat([
      auth.middleware,
      media.middleware,
      social.middleware,
      metrics.middleware,
      resources.middleware,
      conversions.middleware,
      workspaces.middleware,
      performance.middleware,
      csrf.middleware,
      countries.middleware,
      admin.middleware,
      campaignLeaks.middleware,
      businessOverview.middleware,
      brandOverview.middleware,
      competitorsMonitoring.middleware,
      liveBidding.middleware,
      dashboard.middleware,
      sso.middleware,
      onboard.middleware,
      cockpit.middleware,
      googleAPI.middleware,
      dataApi.middleware,
      conversionsAnalysis.middleware,
      visibility.middleware,
      activations.middleware,
      bidStratTesting.middleware,
      filters.middleware,
      extAPI.middleware,
      jobsAPI.middleware,
      nonBrandedAPI.middleware,
      tagAPI.middleware,
      currencies.middleware,
      brandPulse.middleware,
      exports.middleware,
      leaderboard.middleware,
      brandColorAPI.middleware,
      brandInfringement.middleware,
    ]),
});

export default store;
export type RootState = ReturnType<typeof reducer>;
export type ApiState = typeof apiState;
